var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "card-comparison-section",
    style: _vm.style
  }, [_c('Container', [_c('div', {
    staticClass: "section-header flex flex-col items-center text-center mb-12"
  }, [_c('h1', {
    staticClass: "card-compare-heading"
  }, [_vm._v("\n\t\t\t\tYour debit card should"), _c('br'), _vm._v("\n\t\t\t\tbe\n\t\t\t\t"), _c('img', {
    attrs: {
      "src": require("assets/images/green_stars.png"),
      "alt": "Green stars"
    }
  }), _vm._v("Extra"), _c('img', {
    attrs: {
      "src": require("assets/images/green_stars.png"),
      "alt": "Green stars"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "table-col"
  }, [_c('div', {
    staticClass: "table-row-header"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-col border-trl"
  }, [_c('div', {
    staticClass: "table-row-header"
  }, [_c('img', {
    staticClass: "image-of-card",
    attrs: {
      "src": "https://assets.website-files.com/61c293aa98cb80a28661cc90/637d02cdefd4769f64876ef4_extra_final_card_render_front_776_1200_NOHUNTING.png",
      "alt": "Extra debit card"
    }
  }), _vm._v("\n\t\t\t\t\t\tExtra Debit Card\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "table-col flex flex-col"
  }, [_c('div', {
    staticClass: "table-row-header"
  }, [_c('img', {
    staticClass: "image-of-card",
    attrs: {
      "src": "https://assets.website-files.com/61c293aa98cb80a28661cc90/6400de71b0573358859aeb1f_other-cards.png",
      "alt": "Other debit cards"
    }
  }), _vm._v("\n\t\t\t\t\t\tOther Secured Cards\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "table-col"
  }, [_vm._v("Debit that builds credit")]), _vm._v(" "), _c('div', {
    staticClass: "table-col border-lr"
  }, [_c('GreenCheck')], 1), _vm._v(" "), _c('div', {
    staticClass: "table-col"
  }, [_c('GreyCross')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "table-col"
  }, [_vm._v("Earn reward points")]), _vm._v(" "), _c('div', {
    staticClass: "table-col border-lr"
  }, [_c('GreenCheck')], 1), _vm._v(" "), _c('div', {
    staticClass: "table-col"
  }, [_c('GreyCross')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "table-col"
  }, [_vm._v("Connects with any bank")]), _vm._v(" "), _c('div', {
    staticClass: "table-col border-lr"
  }, [_c('GreenCheck')], 1), _vm._v(" "), _c('div', {
    staticClass: "table-col"
  }, [_c('GreyCross')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "table-col"
  }, [_vm._v("No security deposit")]), _vm._v(" "), _c('div', {
    staticClass: "table-col border-lr"
  }, [_c('GreenCheck')], 1), _vm._v(" "), _c('div', {
    staticClass: "table-col"
  }, [_c('GreenCheck')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "table-col"
  }, [_vm._v("No credit checks")]), _vm._v(" "), _c('div', {
    staticClass: "table-col border-lr"
  }, [_c('GreenCheck')], 1), _vm._v(" "), _c('div', {
    staticClass: "table-col"
  }, [_c('GreyCross')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-row__final"
  }, [_c('div', {
    staticClass: "table-col"
  }, [_vm._v("Daily payments")]), _vm._v(" "), _c('div', {
    staticClass: "table-col border-blr"
  }, [_c('GreenCheck')], 1), _vm._v(" "), _c('div', {
    staticClass: "table-col"
  }, [_c('GreenCheck')], 1)])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };